import { render, staticRenderFns } from "./OrdersOverview.vue?vue&type=template&id=3d83e014&scoped=true&"
import script from "./OrdersOverview.vue?vue&type=script&lang=js&"
export * from "./OrdersOverview.vue?vue&type=script&lang=js&"
import style0 from "./OrdersOverview.vue?vue&type=style&index=0&id=3d83e014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d83e014",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d83e014')) {
      api.createRecord('3d83e014', component.options)
    } else {
      api.reload('3d83e014', component.options)
    }
    module.hot.accept("./OrdersOverview.vue?vue&type=template&id=3d83e014&scoped=true&", function () {
      api.rerender('3d83e014', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/OrdersOverview.vue"
export default component.exports